import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ReactPlayer from 'react-player'
import gplay from "../assets/home/gplay.png";
import apple from "../assets/home/apple.png";
import tick from "../assets/home/tick.png";
import fadelogo from "../assets/home/fadelogo.png";
import ornament from "../assets/home/ornament.png";
import eng from "../assets/eng.png"
import Kids from "../assets/kids.png"
import IELTS from "../assets/IELTS.png"
import { Accordion, Card } from "react-bootstrap";

import AuthModal from "../components/AuthModals/AuthModal";
import { initGA, initPixel } from "../helpers/CampaignEvents";
const user = JSON.parse(localStorage.getItem("USER"));


const HomePageRedesign = () => {
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
    let { id } = useParams();
    const imgUrl = "https://s3.ap-south-1.amazonaws.com/cdn.clapingo.com/clapingoWeb";

    // const query = useQuery()
    // const influencerCode = query.get("influenercode");

    //ENCODE INFLUENCER CODE
    // var encodedString = window.btoa( baseString ); 
    //DECODE INFLUENCER CODE



    useEffect(() => {
        initPixel()
        initGA()
        if (id) {
            var decodedString = window.atob(id);
            localStorage.setItem("INFLUENCER_CODE", decodedString)
        }
    }, [])

    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();
    useEffect(() => {
        if (user) {
            history.push("/dashboard");
        }
    }, [user]);

    useEffect(() => {
        AOS.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'aos-animate', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
            disableMutationObserver: false, // disables automatic mutations' detections (advanced)
            debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
            throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 120, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 1600, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

        });
    });

    const closeModal = () => setOpenModal(false);
    return (
        <>
            <AuthModal />
            <div className="auth_model_wrapper">
                <AuthModal openModal={openModal} closeModal={closeModal} />
            </div>
            <div style={{ backgroundColor: "#ffffff" }}>
                {/* HEADER SECTION STARTS */}
                <div className="header_section" data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div className="d-flex align-items-center ">
                        <div className="container mt-0 mt-md-3">
                            <div className="row pt-2 mt-3">
                                <div className="col-md-7 order-2 order-md-1 order-lg-1 d-flex flex-column justify-content-center">
                                    <div className="circle blue">
                                    </div>
                                    <h1 className="header_text">
                                        Live, <span className="one">one-on-one</span> online classes for English .{" "}<br />
                                        {/* <span className="one">one-on-one</span> video call */}
                                    </h1>

                                    {/* <h4 className=" text-white " style={{fontWeight:"bold"}}>Exclusive Offer Download the Android App and book your trial at just   ₹1/-</h4> */}
                                    <div className="mt-md-2 ">
                                        <p className="sub_header_text">
                                            Practice english conversation with excellent
                                            communicators <br />across the country and speak
                                            like a <span style={{ fontWeight: "bold", color: "black" }}>PRO</span>
                                        </p>
                                    </div>
                                    <div className="pt-md-2 mt-1 home_button_container">
                                        <button
                                            className="bookBTN1"
                                            onClick={() => history.push("/book-demo/:component")}
                                        >
                                            Book Your Trial @ {time_zone.country === "IN" ? "₹99" : "$1.99"}
                                        </button>
                                    </div>
                                    <div className="download-div">
                                        <p className="app-download">Download the App</p>
                                        <div>
                                            <span className="mr-2">
                                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.app.clapingo&hl=en_IN&gl=US">
                                                    <img src={`https://images.weserv.nl/?url=${imgUrl}/gplay.png&w=135&h=40&output=webp`} alt="google play logo" />
                                                </a>
                                            </span>

                                            <span className="mr-2">
                                                <a target="_blank" href="https://apps.apple.com/in/app/clapingo/id1595487516">
                                                    <img src={`https://images.weserv.nl/?url=${imgUrl}/apple.png&w=135&h=40&output=webp`} alt="apple logo" />
                                                </a>
                                            </span>


                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5 mobile order-1 mt-5">
                                    <div className="top-img">
                                        <img src={`https://images.weserv.nl/?url=${imgUrl}/top.png&w=542&h=484&output=webp`} alt="clapingo header" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                {/* HEADER SECTION ENDSS */}

                {/* SUBSCRIPTION SECTION STARTS */}
                <div className="home-subscription pt-2" data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div className="subscription-title">
                        Planning to<br /><span style={{ color: "#4A6EE0" }}>Subscribe</span> Clapingo?
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div>
                                <div className="sub-card">
                                    <div className="top">
                                        <div className="top-img">
                                            <img src={eng} height="70" alt="eng" />
                                            <span className="span-text">English</span>
                                        </div>
                                    </div>
                                    <div className="plan">
                                        6 months
                                    </div>
                                    <div className="this">This plan includes:<br />
                                        <ul style={{ color: "black" }}>
                                            <li>- 5 days a week</li>
                                            <li>- 120 sessions for 6 months</li>
                                            <li>- one on one sessions</li>
                                        </ul>  </div>
                                    <button className="card-btn" onClick={() => history.push("/home-subscription?type=adults")}>
                                        Buy this Plan
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <div className="sub-card1">
                                    <div className="top">
                                        <div className="top-img">
                                            <img src={Kids} height="70" alt="eng" />
                                            <span className="span-text">Kids</span>
                                        </div>
                                    </div>
                                    <div className="plan">
                                        NOVICE PACK
                                    </div>
                                    <div className="this">This plan includes:<br />
                                        <ul style={{ color: "black" }}>
                                            <li>- 60 sessions</li>
                                            <li>- 6 months validity</li>
                                            <li>- one on one sessions for kids</li>
                                        </ul>  </div>
                                    <button className="card-btn" onClick={() => history.push("/home-subscription?type=kids")}>
                                        Buy this Plan
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <div className="sub-card2">
                                    <div className="top">
                                        <div className="top-img">
                                            <img src={IELTS} height="70" alt="eng" />
                                            <span className="span-text">IELTS</span>
                                        </div>
                                    </div>
                                    <div className="plan">
                                        3 months
                                    </div>
                                    <div className="this">This plan includes:<br />
                                        <ul style={{ color: "black" }}>
                                            <li>- 3 days a week</li>
                                            <li>- 36 sessions for 3 months</li>
                                            <li>- one on one IELTS sessions </li>
                                        </ul>  </div>
                                    <button className="card-btn" onClick={() => history.push("/home-subscription?type=IELTS")}>
                                        Buy this Plan
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* SUBSCRPITION SECTION ENDS */}

                {/* WHAT WE OFFER SECTION STARTS */}
                <div className="what_we_offer " data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 ">
                                <p className="convo-text mt-5">Conversations are<br /> easily forgotten.<br />
                                    <span style={{ fontWeight: "bold" }}>
                                        Recall and share every<br /> detail with <span className="one">Clapingo.</span>
                                    </span>
                                </p>
                                <button
                                    onClick={() => history.push("/book-demo/:component")}
                                    className="booktrial-BTN2">Book Your Trial</button>
                            </div>
                            <div className="col-md-6">
                                <div className="vid-div">
                                    <ReactPlayer
                                        className='react-player'
                                        width='100%'
                                        height='100%'
                                        controls
                                        url="https://youtu.be/EnFqoUEKoHE"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* WHAT WE OFFER SECTION ENDS */}

                {/* WHY CLAPINGO SECTIONS STARTS */}
                <div className="why_clapingo " data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="fadelogo">
                                    <img src={fadelogo} alt="logo" />
                                </div>
                                <div className="margin-wrapper">
                                    <p className="title-why">Why <span className="one" style={{ fontWeight: "bold" }}>Clapingo</span> is your<br /> best option?</p>
                                    <div className="points mt-5">
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Practice Speaking Skills</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Recorded Sessions</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Friendly Environment</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Learn at your own pace</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Undivided Attention</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="ornament">
                                    <img src={ornament} alt="logo" />
                                </div>
                                <div className="ornament2">
                                    <img src={ornament} alt="logo" />
                                </div>
                                <div className="ml-3 mt-5 why-img">
                                    <img src={`https://images.weserv.nl/?url=${imgUrl}/whyclapingo.png&w=542&h=484&output=webp`} width="500px" height="400px" alt="why clapingo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* WHY CLAPINGO SECTIONS ENDS */}

                {/* CLAPINGO TEACHERS SECTION STARTS */}
                <div className="learners" data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div className="container">
                        <div className="container">
                            <div className="text-center ">
                                <button
                                    onClick={() => history.push("/book-demo/:component")}
                                    className="booktrial-BTN3">Book your Trial</button>
                                <p className="learner-title mt-4 mb-3">Just don't take our word for it.<br />Look what our <span className="one">Learners</span> have to say.</p>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="testimonial-flex">
                                            <div>
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/testi1.png&w=343&h=377&output=webp`} alt="testimonial" />
                                            </div>
                                            <div className="ml-4 mr-4">
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/testi3.png&w=434&h=433&output=webp`} alt="testimonial" />
                                            </div>
                                            <div>
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/testi2.png&w=343&h=378&output=webp`} alt="testimonial" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                {/* CLAPINGO TEACHER SECTION ENDS */}
                {/* BOTTOM SECTION STARTS */}
                <div className="bottom_section" data-aos="fade-up" style={{ overflowX: "hidden" }}>
                    <div className="d-flex align-items-center ">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <p className="bottom-title mt-5">Download our <span className="one" style={{ fontWeight: "bold" }}>App</span> now!</p>
                                    <div className="row mt-5 ml-1">
                                        <div className="d-inline">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">100k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Mobile Downloads</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-inline inline-marginA">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">80k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Happy Learners</h6>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div className="row mt-3 ml-1">
                                        <div className="d-inline">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">53k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Sessions<br /> per month</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-inline inline-marginB">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">200<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Speakers around<br /> the country</h6>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="mt-3">
                                        <span className="mr-2">
                                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.app.clapingo&hl=en_IN&gl=US">
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/gplay.png&w=135&h=40&output=webp`} alt="google play logo" />
                                            </a>
                                        </span>
                                        <span className="mr-2">
                                            <a target="_blank" href="https://apps.apple.com/in/app/clapingo/id1595487516">
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/apple.png&w=135&h=40&output=webp`} alt="apple logo" />
                                            </a>
                                        </span>

                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="bottom-img">
                                        <img src={`https://images.weserv.nl/?url=${imgUrl}/bottom.png&w=735&h=836&output=webp`} alt="bottom" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* BOTTOM SECTION ENDS */}

                {/* FAQ SECTION */}
                <div data-aos="fade-up" className="container">
                    <div className="faq">
                        <h1>
                            Have a question?
                            <br />
                            Find the answers in our{" "}
                            <span style={{ color: "#4DC591" }}>FAQ</span>:
                        </h1>
                        <div className="tab">


                            <Accordion defaultActiveKey="0">
                                <Card style={{ cursor: "pointer" }} className="mt-5  p-0">
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className="accord"
                                        eventKey="1"
                                    >
                                        <div className="d-flex">
                                            <div className="circle my-auto">1</div>
                                            <p className="ml-3">
                                                What is Clapingo?
                                            </p>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <span style={{ fontWeight: "bold" }}>Clapingo</span>  is a unique platform where you practise conversations live with various tutors across the country. This is a judgment-free space where people can freely speak with a diverse set of people from different backgrounds
                                            <br />
                                            <br />

                                            <span style={{ fontWeight: "bold" }}>Why Clapingo?</span>
                                            <ul className="ml-5">
                                                <li style={{ color: "black", listStyleType: "disc" }}>You get one-on-one tutoring so you have the freedom to ask for whatever help you need.</li>
                                                <li style={{ color: "black", listStyleType: "disc" }}>The tutors on Clapingo are excellent communicators, they also help learners identify their weak areas and suggest ways to transform</li>
                                                <li style={{ color: "black", listStyleType: "disc" }}>Regular conversation practice automatically helps anyone master speaking skills.</li>
                                                <li style={{ color: "black", listStyleType: "disc" }}>Get access to all your recorder videos so that you can analyse yourself later</li>
                                                <li style={{ color: "black", listStyleType: "disc" }}>Talk on a different topic in each session using Clapingo's Session Documents.</li>

                                            </ul>

                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card style={{ cursor: "pointer" }} className="mt-2  p-0">
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className="accord"
                                        eventKey="2"
                                    >
                                        <div className="d-flex">
                                            <div className="circle my-auto">2</div>
                                            <p className="ml-3">
                                                How to book your Clapingo Sessions?
                                            </p>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body>
                                            Once you've taken a subscription, you can reserve your Clapingo Sessions according to your availability and select a tutor of your choice. You can reserve your Clapingo sessions by clicking on the book button in the "Upcoming Sessions" tab.

                                            <br />
                                            <br />
                                            You can Subscribe to Clapingo and transform your Spoken English Ability from <a style={{ color: "lightgreen" }} href="https://clapingo.com/plans">here</a>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card style={{ cursor: "pointer" }} className="mt-2  p-0">
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className="accord"
                                        eventKey="3"
                                    >
                                        <div className="d-flex">
                                            <div className="circle my-auto">3</div>
                                            <p className="ml-3">
                                                How many sessions can I book in a week?
                                            </p>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="3">
                                        <Card.Body>
                                            It ranges from 1-7 Sessions per week based on your current subscription limits. If you feel that you need more sessions in a week to improve your skills, you can always choose to upgrade the plan.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card style={{ cursor: "pointer" }} className="mt-2  p-0">
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className="accord"
                                        eventKey="4"
                                    >
                                        <div className="d-flex">
                                            <div className="circle my-auto">4</div>
                                            <p className="ml-3">
                                                What is included in the Subscription?
                                            </p>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="4">
                                        <Card.Body>
                                            Along with One on One Video Sessions with our tutors, your Clapingo Subscription also includes access to Session Documents, the Clapingo Video Library and all other benefits made available on the Clapingo Platform.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>

                                <Card style={{ cursor: "pointer" }} className="mt-2  p-0">
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className="accord"
                                        eventKey="5"
                                    >
                                        <div className="d-flex">
                                            <div className="circle my-auto">5</div>
                                            <p className="ml-3">
                                                Can I choose a tutor of my choice OR change a tutor at any point
                                            </p>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="5">
                                        <Card.Body>
                                            You can speak to a new tutor in every session. So if you have 20 sessions, you can choose to speak to 20 different tutors. We encourage you to speak to as many tutors as possible to help boost your confidence and also ensure a holistic improvement in your spoken English skills. You can also choose to meet with the same tutor.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>





                            </Accordion>



                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomePageRedesign;